import React, {Component} from 'react'

class Home extends Component {

    render() {
        return <div><h2>Loading Content...</h2></div>
    }
}

export default Home


// WEBPACK FOOTER //
// ./src/Components/Home.js